import { AxiosResponse } from 'axios'
import { IUsuarioAtividade } from 'src/contexts/Atividade/context'
import {
  IColunaKanban,
  ISolicitacaoKanban
} from 'src/contexts/SolicitacoesKanban/types'
import SynTipoParceiro from 'src/core/consts/synTipoParceiro'
import api from 'src/services/api'

import {
  AlterarStatusPropostaCommand,
  AlterarStatusSolicitacaoOcamentoCommand,
  IHonorariosResponse,
  IOrcamentoDetalhadoResponse,
  IOrcamentoParceiroDetalhadoResponse,
  IOrcamentoPreenchido,
  ItemListagemOcorrenciaResponse,
  //SalvarPacoteCommand,
  ItemListagemSolicitacaoOrcamentoResponse,
  ListagemQuery,
  ListagemResponse,
  LogStatusSolicitacaoOrcamentoResponse,
  NovaOcorrenciaSolicitacaoOcamentoCommand,
  ObjetoDescricaoGenerico,
  OperacionalResponse,
  ResponsavelUsuarioResponse,
  ResponderOcorenciaCommand,
  SalvarHonorarioCommand,
  SetarTagCommand,
  SolicitarOcamentoCommand,
  SolicitarOcamentoHospitalCommand,
  SolicitarOcamentoInteligenteCommand,
  TagResponse
} from 'src/types'

export const listagemOrcamento: (
  query: ListagemQuery
) => Promise<
  AxiosResponse<ListagemResponse<ItemListagemSolicitacaoOrcamentoResponse>>
> = query => {
  return api.get(`/solicitacaoOrcamento/listagem?${new URLSearchParams(query)}`)
}

export const listagemKanban: () => Promise<
  AxiosResponse<IColunaKanban<ISolicitacaoKanban>[]>
> = () => {
  return api.get('/solicitacaoOrcamento/listagemKanban')
}

export const listagemColunaKanban: (
  colunaId: string,
  qtdCarregados: number
) => Promise<AxiosResponse<ISolicitacaoKanban[]>> = (
  colunaId,
  qtdCarregados
) => {
  return api.get(
    `/solicitacaoOrcamento/listagemKanban/coluna/${colunaId}?qtdCarregados=${qtdCarregados}`
  )
}

export const listagemOrcamentoId: (
  codigo: string,
  perfilAtual: string
) => Promise<AxiosResponse<ItemListagemSolicitacaoOrcamentoResponse>> = (
  codigo,
  perfilAtual
) => {
  return api.get(`/solicitacaoOrcamento/${codigo}/listagemPorId/${perfilAtual}`)
}

export const listagemOrcamentoParceiro: (
  query: ListagemQuery,
  mostrarInteligente: boolean,
  mostrarCotacao: boolean
) => Promise<
  AxiosResponse<ListagemResponse<ItemListagemSolicitacaoOrcamentoResponse>>
> = (query, mostrarInteligente, mostrarCotacao) => {
  return api.get(
    `/solicitacaoOrcamento/parceiro?${new URLSearchParams(
      query
    )}&mostrarCotacao=${mostrarCotacao}&mostrarInteligente=${mostrarInteligente}`
  )
}

export const obterOrcamentoPorId: (
  id: string
) => Promise<AxiosResponse<IOrcamentoDetalhadoResponse>> = id => {
  return api.get(`/solicitacaoOrcamento/${id}`)
}
export const obterParceirosOPMEPorSolicitacao: (
  id: string
) => Promise<AxiosResponse<ObjetoDescricaoGenerico[]>> = id => {
  var response = api.get('/solicitacaoOrcamento/opme/' + id)
  return response
}

export const obterLoacaisAtendimentoAsync: (
  id: string
) => Promise<AxiosResponse<ObjetoDescricaoGenerico[]>> = id => {
  var response = api.get('/solicitacaoOrcamento/hospitais/' + id)
  return response
}

export const obterOrcamentoParceiroPorId: (
  id: string
) => Promise<AxiosResponse<IOrcamentoParceiroDetalhadoResponse>> = id => {
  return api.get(`/solicitacaoOrcamento/${id}/parceiro`)
}
export const salvarSolicitacaoOrcamento: (
  command: SolicitarOcamentoCommand
) => Promise<AxiosResponse<string>> = command => {
  let body = { ...command }
  if (body.paciente) {
    body.paciente.id = !body.paciente.id ? null : body.paciente.id
  }
  return api.post('/solicitacaoOrcamento', body)
}

export const salvarSolicitacaoOrcamentoInteligente: (
  command: SolicitarOcamentoInteligenteCommand
) => Promise<AxiosResponse<string>> = command => {
  let body = { ...command }
  if (body.paciente) {
    body.paciente.id = !body.paciente.id ? null : body.paciente.id
  }
  return api.post('/solicitacaoOrcamento/inteligente', body)
}

export interface ValoresInteligentesResponse {
  descricao?: string
  internacaoId?: string
  apartamento?: boolean
  propostaDiasUteis?: boolean
  propostaBaixoFluxo?: boolean
  horariosBaixoFluxo?: string | null
  propostaCentroCirurgicoAmbulatorial?: boolean
  cartaoDesconto?: boolean
  valor?: number
  valorProposta?: number
  valorPropostaEnfermaria?: number
  valorPropostaApartamento?: number
}

export const obterValoresOrcamentoInteligente: (
  command: SolicitarOcamentoInteligenteCommand
) => Promise<AxiosResponse<ValoresInteligentesResponse[]>> = command => {
  let body = { ...command }
  if (body.paciente) {
    body.paciente.id = !body?.paciente?.id ? null : body?.paciente?.id
  }
  return api.post('/solicitacaoOrcamento/inteligente/valores', command)
}

export const excluirOrcamento: (id: string) => Promise<boolean> = async id => {
  await api.delete(`/solicitacaoOrcamento/${id}`)
  return true
}

export const alterarStatusSolicitacaoOrcamento: (
  command: AlterarStatusSolicitacaoOcamentoCommand
) => Promise<AxiosResponse<void>> = command => {
  return api.post('/solicitacaoOrcamento/alterarStatus', command)
}

export const novaOcorrenciaSolicitacaoOrcamento: (
  command: NovaOcorrenciaSolicitacaoOcamentoCommand
) => Promise<AxiosResponse<void>> = command => {
  return api.post(`/solicitacaoOrcamento/${command.id}/ocorrencias`, command)
}

export const cadastrarResponsavelSolicitacaoOrcamento: (
  idUsuario: string,
  idSolicitacao: string
) => Promise<AxiosResponse<void>> = async (idUsuario, idSolicitacao) => {
  return api.post(
    `/solicitacaoOrcamento/${idUsuario}/responsavel/${idSolicitacao}`
  )
}

export const alterarStatusProposta: (
  command: AlterarStatusPropostaCommand
) => Promise<AxiosResponse<void>> = command => {
  return api.post('/proposta/alterarStatus', command)
}
export const alterarStatusPropostaEncerrada: (
  command: AlterarStatusPropostaCommand
) => Promise<AxiosResponse<void>> = command => {
  return api.post('/proposta/voltarUltimoStatus', command)
}
export const responderOcorenciaSolicitacaoOrcamento: (
  command: ResponderOcorenciaCommand
) => Promise<AxiosResponse<void>> = command => {
  return api.post('/solicitacaoOrcamento/responderOcorencia', command)
}
export const obterStatusSolicitacaoOrcamento: () => Promise<
  AxiosResponse<ObjetoDescricaoGenerico[]>
> = () => {
  return api.get('/solicitacaoOrcamento/Status')
}
export const obterMotivosSolicitacao: () => Promise<
  AxiosResponse<ObjetoDescricaoGenerico[]>
> = () => {
  return api.get('/solicitacaoOrcamento/motivoCancelamento')
}
export const obterLogStatusSolicitacaoOrcamento: (
  id: string,
  perfilAtual: string
) => Promise<AxiosResponse<LogStatusSolicitacaoOrcamentoResponse[]>> = (
  id,
  perfilAtual
) => {
  return api.get(`/solicitacaoOrcamento/LogStatus/${id}/${perfilAtual}`)
}
export const obterOrcamentosParaSolicitacao: (
  id: string
) => Promise<AxiosResponse<IOrcamentoPreenchido>> = id => {
  return api.get(`/solicitacaoOrcamento/${id}/orcamentos`)
}
/* GERENCIAR TAGS DA SOLICITAÇÃO */

export const listarTodasTags: () => Promise<
  AxiosResponse<TagResponse[]>
> = () => {
  return api.post('/solicitacaoOrcamento/tag/listagem')
}
export const listarTagsPorSolicitacao: (
  solicitacaoId?: string
) => Promise<AxiosResponse<TagResponse[]>> = solicitacaoId => {
  return api.post(`/solicitacaoOrcamento/tag/listagem/${solicitacaoId}`)
}
export const cadastrarTag: (
  descricao: string
) => Promise<AxiosResponse> = descricao => {
  const body = {
    descricao
  }
  return api.post('/tag', body)
}

export const incluirTag: (
  command: SetarTagCommand
) => Promise<AxiosResponse> = command => {
  return api.post('/solicitacaoOrcamento/tag/incluir', command)
}
export const removerTag: (
  command: SetarTagCommand
) => Promise<AxiosResponse> = command => {
  return api.post('/solicitacaoOrcamento/tag/remover', command)
}
export const deleteTag: (tagId: string) => Promise<AxiosResponse> = tagId => {
  const body = {
    tagId
  }

  return api.post('/tag/excluir', body)
}

export const listagemOrcamentoPaciente: (
  query: ListagemQuery
) => Promise<
  AxiosResponse<ListagemResponse<ItemListagemSolicitacaoOrcamentoResponse>>
> = query => {
  return api.get(
    `/solicitacaoOrcamento/listagem/paciente?${new URLSearchParams(query)}`
  )
}

export const salvarSolicitacaoOrcamentoHospital: (
  command: SolicitarOcamentoHospitalCommand
) => Promise<AxiosResponse<string>> = command => {
  let body = { ...command }
  body.paciente.id = !body.paciente.id ? null : body.paciente.id
  return api.post('/solicitacaoOrcamento/parceiro', command)
}

export function listagemOrcamentoHospital(
  query: ListagemQuery,
  ehPendenteRevisaoValores: boolean
): Promise<
  AxiosResponse<ListagemResponse<ItemListagemSolicitacaoOrcamentoResponse>>
> {
  return api.get(
    `/solicitacaoOrcamento/parceiro/hospital?${new URLSearchParams(
      query
    )}&ehPendenteRevisaoValores=${ehPendenteRevisaoValores}`
  )
}

export function listagemOcorrencias(
  solicitacaoId: string
): Promise<AxiosResponse<ListagemResponse<ItemListagemOcorrenciaResponse>>> {
  return api.get(`/solicitacaoOrcamento/ocorrencias/${solicitacaoId}`)
}

export function listagemOcorrenciasParceiro(
  solicitacaoId: string,
  tipoParceiro: string
): Promise<AxiosResponse<ListagemResponse<ItemListagemOcorrenciaResponse>>> {
  return api.get(
    `/solicitacaoOrcamento/ocorrencias-parceiro/${solicitacaoId}/${tipoParceiro}`
  )
}

export const obterHonorariosPorId: (
  id: string
) => Promise<AxiosResponse<IHonorariosResponse>> = id => {
  return api.get(`/solicitacaoOrcamento/${id}/honorario`)
}
export const salvarHonorarios: (
  command: SalvarHonorarioCommand
) => Promise<AxiosResponse> = command => {
  return api.post('/solicitacaoOrcamento/salvarHonorario', command)
}
//alterar solicitaçao para Procedimento Realizado
export const alterarStatusProcedimentoRealizado: (
  idSolicitacao: string,
  perfilAtual: string
) => Promise<AxiosResponse> = async (idSolicitacao, perfilAtual) => {
  return await api.put(
    `/solicitacaoOrcamento/${idSolicitacao}/${perfilAtual}/AlterarStatusParaProcedimentoRealizado`
  )
}

export function listarOperacionais(): Promise<
  AxiosResponse<OperacionalResponse[]>
> {
  return api.get('/solicitacaoOrcamento/buscarOperacionais')
}

export function listarResponsaveis(): Promise<
  AxiosResponse<ResponsavelUsuarioResponse[]>
> {
  return api.get('/solicitacaoOrcamento/buscarResponsaveis')
}
export function listarUsuarios(): Promise<AxiosResponse<IUsuarioAtividade[]>> {
  return api.get('/solicitacaoOrcamento/buscarUsuarios')
}

export function listarUsuariosHospital(): Promise<AxiosResponse<IUsuarioAtividade[]>> {
  return api.get('/solicitacaoOrcamento/buscarUsuariosHospital')
}

export const habilitarPagamento: (
  solicitacaoId: string,
  habilitado: boolean
) => Promise<AxiosResponse<string>> = (solicitacaoId, habilitado) => {
  return api.post('/solicitacaoOrcamento/habilitarPagamento', {
    habilitado: habilitado,
    id: solicitacaoId
  })
}

export interface ComprovanteCommand {
  tipo: number
  arquivo: any
  destinatarioId: string
  observacao: string
  solicitacaoId: string
}
export const anexarComprovante: (
  command: ComprovanteCommand
) => Promise<AxiosResponse<any>> = command => {
  const fromData = new FormData()
  fromData.append('Arquivo', command.arquivo)
  fromData.append('Tipo', command.tipo.toString())
  fromData.append('Observacao', command.observacao)
  fromData.append('DestinatarioId', command.destinatarioId)

  return api.post(
    `/solicitacaoOrcamento/${command.solicitacaoId}/comprovantes`,
    fromData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

export interface ComprovanteResponse {
  tipo: number
  observacao: string
  enviadoPor: string
  enviado: string
  url: string
  extensao: string
  contentType: string
  destinatarioId: string
}

export const obterComprovantesOperacional: (
  id: string
) => Promise<AxiosResponse<ComprovanteResponse[]>> = id => {
  return api.get(`/solicitacaoOrcamento/${id}/comprovantes`)
}

export const obterComprovantesHospital: (
  id: string
) => Promise<AxiosResponse<ComprovanteResponse[]>> = id => {
  return api.get(`/solicitacaoOrcamento/${id}/comprovantes/hospital`)
}

export const obterComprovantesPorDestinatario: (
  solicitacaoId: string,
  tipo: number,
  destinatarioId: string,
  perfilAtual: string
) => Promise<AxiosResponse<ComprovanteResponse[]>> = (
  solicitacaoId,
  tipo,
  destinatarioId,
  perfilAtual
) => {
  return api.get(
    `/solicitacaoOrcamento/${solicitacaoId}/comprovantes/${tipo}/${destinatarioId}/${perfilAtual}`
  )
  // return api.post('/solicitacaoOrcamento/comprovantes/', {
  //   habilitado: habilitado,
  //   id: solicitacaoId
  // })
}

export const obterPendencias: () => Promise<AxiosResponse<any>> = () => {
  return api.get('/solicitacaoOrcamento/pendencias')
}

export const liberarEdicao: (
  idSolicitacao: string,
  perfilAtual: string
) => Promise<AxiosResponse> = (idSolicitacao, perfilAtual) => {
  return api.put(
    `/solicitacaoOrcamento/liberarEdicao/${idSolicitacao}/${perfilAtual}`
  )
}
